import { QueueSegment } from '../models/reports.external';
import { getTimestamp } from '../utils/timeUtils';

function getLwtStartTime(segments: QueueSegment[]): number | null {
  if (segments.length > 0) {
    const queuedAtTimes = segments.map(s => getTimestamp(s.queuedAt));
    const oldestSegmentTime = Math.min(...queuedAtTimes);
    return Math.floor(oldestSegmentTime);
  }

  return null;
}

export default getLwtStartTime;